import React from 'react';
import { navigate } from 'gatsby';
import { App } from '@capacitor/app';

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import StoreProvider from './src/store/Provider';
import SocketProvider from './src/providers/Socket';
import { getAppType } from './src/utils/appTypeUtils';
import { AppType } from './src/constants';
import SecureStore from './src/utils/secureStore';
import { handleUniversalLink } from './src/utils/salesAppUtils';

export const onRouteUpdate = ({ location }) => {
  const { pathname } = location;

  const appType = getAppType();
  const isSalesApp = appType === AppType.SALES;

  if (isSalesApp && pathname.startsWith('/admin')) {
    // Intercept navigation when the app is the Sales App
    // and the user attempts to navigate to admin pages.
    navigate('/sales/main', { replace: true });
  }
};

export const onClientEntry = async () => {
  await SecureStore.init();

  App.addListener('appUrlOpen', (data) => {
    handleUniversalLink(data);
  });
};

export const wrapRootElement = ({ element }) => (
  <SocketProvider>
    <StoreProvider element={element} />
  </SocketProvider>
);
